module.exports = __webpack_public_path__ + "media/bootstrap-icons/clock-3e731eb0.svg";